module.exports = __webpack_public_path__ + "media/common/js/components/content-units/templates/innogy-introduction/i2-4-2b695094985fee40fab7b2db770f94fb.svg";